/**
 * The delivery-time text for one shop and one delivery address — the same rule every shop card uses
 * (formatDeliveryEta ∘ computeEtaMinutes: the tenant's own ETA text when set, else the shop's prep time plus
 * travel time for the distance). ``GET /restaurants/{id}?lat&lng`` supplies the shop's prep minutes and distance.
 * Returns null while loading or when the tenant hides ETAs.
 */
import { useEffect, useState } from "react";
import { api } from "./api";
import { useTenant } from "../contexts/TenantContext";
import { computeEtaMinutes, formatDeliveryEta } from "./deliveryEta";

export function useShopEta(restaurantId, addr) {
    const { tenant } = useTenant();
    const [shop, setShop] = useState(null);
    const lat = addr?.lat, lng = addr?.lng;
    useEffect(() => {
        if (!restaurantId) return undefined;
        let alive = true;
        const q = lat != null && lng != null ? `?lat=${lat}&lng=${lng}` : "";
        api.get(`/restaurants/${restaurantId}${q}`)
            .then(({ data }) => { if (alive) setShop(data?.restaurant || null); })
            .catch(() => { if (alive) setShop(null); });
        return () => { alive = false; };
    }, [restaurantId, lat, lng]);
    if (!shop) return null;
    return formatDeliveryEta(tenant, computeEtaMinutes(shop.avg_prep_minutes, shop.distance_km));
}
